// extracted by mini-css-extract-plugin
export default {"ul":"List_ul__SLzBr","ol":"List_ol__u35AT","li":"List_li__u1CDk"};